import React from 'react';
import { BarChart, LabelList, XAxis, Bar, YAxis, Cell, ResponsiveContainer } from 'recharts';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const AdmissionStatus = ({ data }) => {
  const {
    statusNotStarted,
    statusinProgress,
    statusSubmitted,
    statusDenied,
    statusWaitlisted,
    statusDefered,
    statusAccepted,
    statusEnrolled,
  } = data;
  const x = 1.5;

  const graphData = [
    {
      label: 'NOT STARTED',
      x,
      value: statusNotStarted.aggregate.count,
      color: '#F0F0F0',
      strke: '#696D75'
    },
    {
      label: 'IN PROGRESS',
      x,
      value: statusinProgress.aggregate.count,
      color: '#F8F0FF',
      strke: '#8A53FF'
    },
    {
      label: 'SUBMITTED',
      x,
      value: statusSubmitted.aggregate.count,
      color: '#F2F5FE',
      strke: '#547FF6'
    },
    {
      label: 'DENIED',
      strke: '#E62565',
      x, value: statusDenied.aggregate.count,
      color: '#FDECFF'
    },
    {
      label: 'WAITLISTED',
      x,
      value: statusWaitlisted.aggregate.count,
      color: '#FDECFF',
      strke: '#AF22AA'
    },
    {
      label: 'DEFERRED',
      x,
      value: statusDefered.aggregate.count,
      color: '#FEF9EF',
      strke: '#F79900'
    },
    {
      label: 'ACCEPTED',
      x,
      value: statusAccepted.aggregate.count,
      color: '#E3FFF5',
      strke: '#25C186'
    },
    {
      label: 'ENROLLED',
      x,
      value: statusEnrolled.aggregate.count,
      color: '#F5FCF0',
      strke: '#87CF50'
    },
  ];

  const valueAccessor = attribute => ({ payload }) => {
    return payload[attribute];
  };

  return (
    <Card>
      <CardHeader
        title="Count of schools based on admission status"
        titleTypographyProps={{ variant: 'h5' }}
      />
      <CardContent>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={graphData}
            margin={{
              top: 40,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis dy={5}
              tickLine={false}
              axisLine={false}
              dataKey="label"
              tick={{ fontSize: 12, fontWeight: 700, letterSpacing: 2 }}
            />
            <YAxis hide='true' domain={[0, 100]} />
            <Bar
              dataKey="x"
              stackId="a"
            >

              {graphData.map((i, idx) => (
                <Cell key={idx} fill={i.strke} />
              ))}

            </Bar>
            <Bar
              dataKey="value"
              stackId="a"
            >
              <LabelList dy={-6} fill='#171819' fontSize='48' fontWeight='700' position="top" valueAccessor={valueAccessor("value")} />
              {graphData.map((i, idx) => (
                <Cell key={idx} fill={i.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default AdmissionStatus;
